module.exports = __webpack_public_path__ + "static/open-account-a55b9fc75b97ba5a6111e640398a6e50.png";